import useApplicationState from '../hooks/useApplicationState';
import useApplicationActions from '../hooks/useApplicationActions';

var useApplication = () => [useApplicationState(), useApplicationActions()];

export default useApplication;